import '@fontsource/hanken-grotesk/700.css';
import '@fontsource/red-hat-display/400.css';
import '@fontsource/red-hat-display/500.css';
import '@fontsource/red-hat-display/600.css';
import '@fontsource/red-hat-display/700.css';
import '@fontsource/ibm-plex-mono/400.css';
import '@/styles/reset.css';
import '@/styles/tokens.css';
import '@/styles/global.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';
import { createAppRouter } from '@/app/router';
import { applyTheme } from '@/app/theme';
import { applyMotion } from '@/lib/motion';
import { useSettingsStore } from '@/state/settingsStore';
import { removeLegacySongData } from '@/storage/settingsRepo';

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root is missing from index.html');

// Song data is kept for this tab only (ADR 0007); clear what earlier versions saved.
removeLegacySongData();

// Before the first render, so a saved dark theme doesn't flash light.
applyTheme(useSettingsStore.getState().theme);
applyMotion(useSettingsStore.getState().reduceMotion);
useSettingsStore.subscribe((s, prev) => {
  if (s.theme !== prev.theme) applyTheme(s.theme);
  if (s.reduceMotion !== prev.reduceMotion) applyMotion(s.reduceMotion);
});

createRoot(container).render(
  <StrictMode>
    <RouterProvider router={createAppRouter()} />
  </StrictMode>,
);
